import { createFeature, createReducer, on } from '@ngrx/store';
import { AuthLoginResponseSuccessDto, UserView } from '../../_generated';
import { AuthActions } from '../actionstypes/auth/auth.actiontype';

export const authFeatureKey = 'auth';

export interface AuthState {
  user: UserView | null;
  isLoading: boolean | null;
  isChangePasswordRequired: boolean | null;
  isConfirmChangePasswordRequired: boolean | null;
  error: string | null;
  success: string | null;
  session: AuthLoginResponseSuccessDto | null;
}

export const initialState: AuthState = {
  user: null,
  isLoading: null,
  isChangePasswordRequired: null,
  isConfirmChangePasswordRequired: null,
  error: null,
  success: null,
  session: null,
};

export const reducer = createReducer(
  initialState,
  on(AuthActions.authenticateUser, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(AuthActions.signIn, (state) => ({
    ...state,
    error: null,
    isLoading: true,
  })),
  on(AuthActions.signInSuccess, (state) => ({
    ...state,
    error: null,
    isLoading: false,
  })),
  on(AuthActions.signInFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false,
  })),
  on(AuthActions.authenticateUserSuccess, (state, { user }) => ({
    ...state,
    user: { ...user },
    error: null,
    isLoading: false,
  })),
  on(AuthActions.authenticateUserFailure, (state, { error }) => ({
    ...state,
    error,
    user: null,
    isLoading: false,
  })),
  on(AuthActions.refreshTokensSuccess, (state) => ({
    ...state,
    error: null,
  })),
  on(AuthActions.refreshTokensFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(AuthActions.changePasswordRequired, (state, { response }) => ({
    ...state,
    isChangePasswordRequired: true,
    session: response,
  })),
  on(AuthActions.changePasswordSuccess, (state) => ({
    ...state,
    isChangePasswordRequired: false,
    session: null,
  })),
  on(AuthActions.changePasswordFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(AuthActions.confirmChangePasswordRequired, (state, { response }) => ({
    ...state,
    isConfirmChangePasswordRequired: true,
    session: response,
  })),
  on(AuthActions.confirmChangePasswordSuccess, (state) => ({
    ...state,
    isConfirmChangePasswordRequired: false,
  })),
  on(AuthActions.confirmChangePasswordFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(AuthActions.logoutSuccess, (state) => ({
    ...state,
    user: null,
    session: null,
    isLoading: false,
    error: null,
    success: null,
    isChangePasswordRequired: null,
    isConfirmChangePasswordRequired: null,
  })),
  on(AuthActions.forgotPassword, (state) => ({
    ...state,
    isLoading: true,
    error: null,
    success: null,
  })),
  on(AuthActions.forgotPasswordSuccess, (state, { message }) => ({
    ...state,
    isLoading: false,
    success: message,
  })),
  on(AuthActions.forgotPasswordFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(AuthActions.confirmForgotPassword, (state) => ({
    ...state,
    isLoading: true,
    error: null,
    success: null,
  })),
  on(AuthActions.confirmForgotPasswordSuccess, (state) => ({
    ...state,
    isLoading: false,
    success: 'reset_password.success_message',
  })),
  on(AuthActions.confirmForgotPasswordFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
);

export const authFeature = createFeature({
  name: authFeatureKey,
  reducer,
});
